"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _CellWithIcon = _interopRequireDefault(require("./CellWithIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellWithLinkIcon(_ref) {
  var type = _ref.type,
      href = _ref.href,
      size = _ref.size;
  var cellWithIcon = (0, _CellWithIcon.default)(type, size);

  if (href !== undefined) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: href
    }, cellWithIcon);
  }

  return cellWithIcon;
}

CellWithLinkIcon.propTypes = {
  type: _propTypes.default.string.isRequired,
  size: _propTypes.default.number,
  href: _propTypes.default.string
};
CellWithLinkIcon.defaultProps = {
  href: undefined,
  size: 20
};
var _default = CellWithLinkIcon;
exports.default = _default;